export default "__VITE_ASSET__CS6FWKBt__"